import React from "react";

import { faEye } from "@performyard/fontawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@performyard/fontawesome/react-fontawesome";
import { Text } from "@performyard/py-components";
import { SurveyAnswerJson, SurveyQuestionJson } from "@performyard/service-contracts";

import { QuestionsForm } from "./QuestionsForm";

export const Survey = ({
	surveyName,
	questions,
	onSubmit,
	isPreview = false,
}: {
	surveyName: string;
	questions: SurveyQuestionJson[];
	onSubmit: (answers: Record<string, SurveyAnswerJson["value"]>) => void;
	isPreview?: boolean;
}) => {
	return (
		<div className="flex w-[800px] flex-col gap-4 whitespace-normal rounded-[4px] bg-neutral-0 p-10">
			<div className="flex flex-col gap-4">
				<div className="flex items-start justify-between">
					<div className="w-[calc(100%-100px)] flex-1">
						<Text data-testid="survey-name" size="sub-heading" weight="semi-bold">
							{surveyName}
						</Text>
					</div>
					{isPreview && (
						<Text
							overrideElement="span"
							data-testid="preview-indicator"
							size="paragraph-2"
							weight="semi-bold"
							color="neutral-5"
						>
							<div className="mt-1 flex items-center gap-1">
								<FontAwesomeIcon icon={faEye} size="xs" />
								Preview
							</div>
						</Text>
					)}
				</div>
				<div className="h-[1px] w-full bg-neutral-2" />
			</div>
			<div className="flex flex-col gap-6">
				<QuestionsForm questions={questions} onSubmit={onSubmit} />
			</div>
		</div>
	);
};
